import { createAsyncThunk } from "@reduxjs/toolkit";
import { IStoreState } from "App/types";
import { Dispatch } from "react";

import { EquipmentService } from "Venues/services";
import { VENUE_ACTIONS, IEquipment, IEquipmentCategory } from "Venues/types";
import { getEquipmentKey, isPageFetchedInState } from "Venues/utils";

export const createEquipment = createAsyncThunk(
  VENUE_ACTIONS.createEquipment,
  async (equipment: IEquipment, { rejectWithValue }) => {
    try {
      const createdEquipment: any = await EquipmentService.createEquipment(equipment);
      const id = (Object.values(createdEquipment?.equipment) as any)?.[0]?.attributes?.id;
      return { id };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

interface IGetEquipmentData {
  venue: string;
  stage?: string;
  category?: IEquipmentCategory;
  page?: number;
}

export const dispatchGetEquipmentAction = (dispatch: Dispatch<any>, params: IGetEquipmentData) => {
  const paginationKey = getEquipmentKey(params.venue);

  return dispatch(getEquipment({ paginationKey, params, page: params.page || 1 }));
};

export const getEquipment = createAsyncThunk(
  VENUE_ACTIONS.getEquipment,
  async (
    { params }: { params: IGetEquipmentData; page: number; paginationKey: string },
    { rejectWithValue }
  ) => {
    try {
      return await EquipmentService.getEquipment(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  {
    condition: ({ paginationKey, page }, { getState }) => {
      const state = getState() as IStoreState;

      // do not refetch if equipment page has already been fetched
      return !isPageFetchedInState(state, paginationKey, page);
    },
  }
);

export const editEquipment = createAsyncThunk(
  VENUE_ACTIONS.editEquipment,
  async ({ id, equipment }: { id: string; equipment: IEquipment }, { rejectWithValue }) => {
    try {
      return await EquipmentService.editEquipment(id, equipment);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteEquipment = createAsyncThunk(
  VENUE_ACTIONS.deleteEquipment,
  async (id: string, { rejectWithValue }) => {
    try {
      await EquipmentService.deleteEquipment(id);
      return;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);
